module.exports = __webpack_public_path__ + "static/media/buy_req_make_12.fbe1c25f.jpg";